import React from 'react';
import TaxbillListContainer from '../../containers/taxbillmng/TaxbillListContainer';

const TaxbillListPage = () => {
  return <TaxbillListContainer/>
};

export default TaxbillListPage;
